<script lang="ts">
  import type { Occurrence, Place } from "../../types";
  import { getNow, getTimeZone } from "../../data/clock";
  import { first } from "lodash-es";
  import { getScheduleGroups } from "../../domain/hours";
  import Timestamp from "../timestamp.svelte";
  import Locale from "../locale.svelte";

  export let time = getNow();
  export let timeZone = getTimeZone();
  export let schedule: Occurrence[] = [];
  export let place: Place;

  $: groups = getScheduleGroups(schedule, $time, $timeZone);

  $: open = first(groups.open);
  $: opening = first(groups.opening);
  $: closingSoon = first(groups.closingSoon);
  $: openingSoon = first(groups.openingSoon);
</script>

<span class="Container">
  {#if open}
    <span class="Label color-status-green">
      <Locale label="hours.open" />
    </span>
    {#if place.startTimeIsAmbiguous != true}
      <Timestamp label="openStatus.until" time={open.until} {timeZone} />
    {/if}
  {:else if closingSoon}
    <span class="Label color-status-orange">
      <Locale label="hours.closingSoon" />
    </span>

    {#if place.endTimeIsAmbiguous != true}
      <span>
        <Timestamp time={closingSoon.until} {timeZone} />
      </span>
    {/if}
  {:else if openingSoon}
    <span class="Label color-status-blue">
      <Locale label="hours.openingSoon" />
    </span>

    {#if place.startTimeIsAmbiguous != true}
      <Timestamp label="hours.atTime" time={openingSoon.from} {timeZone} />
    {/if}
  {:else if opening}
    <span class="Label color-status-gray">
      <Locale label="hours.opening" />
    </span>

    {#if place.startTimeIsAmbiguous != true}
      <Timestamp label="hours.atTime" time={opening.from} {timeZone} />
    {/if}
  {:else}
    <span class="Label color-status-red">
      <Locale label="hours.closed" />
    </span>
  {/if}
</span>

<style>
  .Container {
    line-height: 24px;
  }

  .Label {
    font-weight: 600;
  }
</style>
